<script setup>
import { useRoute } from "vue-router";

import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          navText="Dashboard"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/layout"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Layout"
        >
          <template v-slot:icon>
            <i class="ni ni-cloud-download-95 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/procesarPagos"
          :class="getRoute() === 'tables' ? 'active' : ''"
          navText="Procesar Pagos"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/historialProcesadas"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Historial Pagos Procesados"
        >
          <template v-slot:icon>
            <i class="ni ni-bullet-list-67 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/historialError"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Historial Pagos Error"
        >
          <template v-slot:icon>
            <i class="ni ni-archive-2 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!--
      <li class="nav-item">
        <sidenav-item
          to="/emisores"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Emisores"
        >
          <template v-slot:icon>
            <i class="ni ni-key-25 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          to="/usuarios"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Gestión de Usuarios"
        >
          <template v-slot:icon>
            <i class="ni ni-circle-08 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    --></ul>
  </div>

  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :card="{
        title: 'Need Help?',
        description: 'Please check our docs',
        links: [
          {
            label: 'Documentation',
            route:
              'https://www.creative-tim.com/learning-lab/vue/overview/argon-dashboard/',
            color: 'dark',
          },
          {
            label: 'Buy now',
            route:
              'https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=vadp',
            color: 'success',
          },
        ],
      }"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      nivel: localStorage.getItem("nivel"),
      model: {
        usuario: "",
        password: "",
      },
    };
  },
  methods: {},
};
</script>
//* coment *//
